import { Spinner } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import classNames from 'classnames'

import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import NavigationCards from '../components/NavigationCards/NavigationCards'
import TabButton from '../components/ui/TabButton/TabButton'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import useGetFetchedData from '../hooks/useGetFetchedData'
import { partnershipsParamList } from '../Contansts'

import styles from './pages.module.scss'

function Partnership() {
  const { data, loading, error } = useGetFetchedData(partnershipsParamList)

  const tabs = data?.tabs
  const navigations = data?.pagenavigations
  const pageTitle = data?.pagetitle
  const breadcrumbs = data?.breadcrumbs
  const sectiondata = data?.sectiondata
  const sectiontitle = data?.sectionTitle

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <>
          <div className="page-container">
            <div className="page-header text-center page-title-padding">
              {pageTitle}
            </div>
            <div
              className={classNames('tabs-container tabs-margin', {
                ['centered-tabs-container']: tabs?.length === 1,
                ['justify-normal']: tabs?.length > 1,
              })}
            >
              {tabs?.map((tab, index) => {
                return (
                  <TabButton
                    key={tab.id}
                    id={tab.id}
                    selected={tab.id}
                    label={tab?.link?.label}
                    path={tab?.link?.path}
                    type="link"
                    buttonClassname={styles.partnershipTabWidth}
                  />
                )
              })}
            </div>
          </div>
          <Outlet
            context={{ sectiondata: sectiondata, sectiontitle: sectiontitle }}
          />
          <NavigationCards
            navigations={navigations}
            className={'page-container'}
          />
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </>
      )}
    </>
  )
}

export default Partnership
